import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { faqsData } from '../../../../../data/landingPage/landingPageData';

const FaqAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = faqsData;

  const toggleFaq = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <div className="flex-1 w-full space-y-6 sm:space-y-8">
      <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b49] tracking-tight text-center md:text-left mb-4 sm:mb-6">
        Frequently Asked Questions
      </h2>

      <div className="bg-white rounded-2xl sm:rounded-3xl border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] overflow-hidden">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`border-b border-gray-100 last:border-b-0 transition-colors ${
              openIndex === index ? 'bg-[#f0fdfa]' : 'bg-white hover:bg-gray-50'
            }`}
          >
            <button
              type="button"
              onClick={() => toggleFaq(index)}
              className="w-full flex items-center justify-between p-4 sm:p-5 md:p-6 text-left focus:outline-none cursor-pointer"
            >
              <span
                className={`font-medium text-xs sm:text-sm md:text-base ${
                  openIndex === index ? 'text-[#067978]' : 'text-[#1a2b49]'
                }`}
              >
                {faq.question}
              </span>
              <div className="flex-shrink-0 ml-3 sm:ml-4">
                {openIndex === index ? (
                  <Minus size={18} className="text-[#067978] sm:w-5 sm:h-5" />
                ) : (
                  <Plus size={18} className="text-[#1a2b49] sm:w-5 sm:h-5" />
                )}
              </div>
            </button>
            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-4 sm:px-5 md:px-6 pb-5 sm:pb-6 text-gray-600 font-normal text-xs sm:text-sm leading-relaxed border-t border-[#067978]/10 pt-3 sm:pt-4">
                    {faq.answer}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqAccordion;
